/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import bidRequestsGlyph from '../icons/metallic/bid-requests.svg';
import createParcelsGlyph from '../icons/metallic/create-parcels.svg';
import databaseGlyph from '../icons/metallic/database.svg';
import essGlyph from '../icons/metallic/ess.svg';
import fimoGlyph from '../icons/metallic/fimo.svg';
import homeGlyph from '../icons/metallic/home.svg';
import landScoringGlyph from '../icons/metallic/land-scoring.svg';
import notificationsGlyph from '../icons/metallic/notifications.svg';
import plantsimGlyph from '../icons/metallic/plantsim.svg';
import pvcostingGlyph from '../icons/metallic/pvcosting.svg';
import pvsimGlyph from '../icons/metallic/pvsim.svg';
import settingsGlyph from '../icons/metallic/settings.svg';
import systemAlertsGlyph from '../icons/metallic/system-alerts.svg';
import bidRequestsLightGlyph from '../icons/metallic-light/bid-requests.svg';
import createParcelsLightGlyph from '../icons/metallic-light/create-parcels.svg';
import databaseLightGlyph from '../icons/metallic-light/database.svg';
import essLightGlyph from '../icons/metallic-light/ess.svg';
import fimoLightGlyph from '../icons/metallic-light/fimo.svg';
import homeLightGlyph from '../icons/metallic-light/home.svg';
import landScoringLightGlyph from '../icons/metallic-light/land-scoring.svg';
import notificationsLightGlyph from '../icons/metallic-light/notifications.svg';
import plantsimLightGlyph from '../icons/metallic-light/plantsim.svg';
import pvcostingLightGlyph from '../icons/metallic-light/pvcosting.svg';
import pvsimLightGlyph from '../icons/metallic-light/pvsim.svg';
import settingsLightGlyph from '../icons/metallic-light/settings.svg';
import systemAlertsLightGlyph from '../icons/metallic-light/system-alerts.svg';
import type { MetallicDockGlyph, MetallicGlyphArt } from './components/MetallicDockIcon';

// Sizes match each SVG's root size. Dark glyphs are drawn on the 96px tile, where badged glyphs
// are larger than the plain 63px ones; light glyphs on the 64px tile, where badged glyphs spill
// past the 60px glyph frame.
const art = (src: string, width: number, height: number): MetallicGlyphArt => ({
  src,
  width,
  height,
});
const plain = (dark: string, light: string): MetallicDockGlyph => ({
  dark: art(dark, 63, 63),
  light: art(light, 60, 60),
});
const badged = (dark: string, light: string): MetallicDockGlyph => ({
  dark: art(dark, 65.775, 67.275),
  light: art(light, 60.5, 61.5),
});

export const metallicGlyphs = {
  home: plain(homeGlyph, homeLightGlyph),
  database: plain(databaseGlyph, databaseLightGlyph),
  pvsim: plain(pvsimGlyph, pvsimLightGlyph),
  pvcosting: badged(pvcostingGlyph, pvcostingLightGlyph),
  ess: badged(essGlyph, essLightGlyph),
  plantsim: plain(plantsimGlyph, plantsimLightGlyph),
  // PlantSim with the PVCosting coin badge.
  fimo: badged(fimoGlyph, fimoLightGlyph),
  bidRequests: {
    dark: art(bidRequestsGlyph, 63, 65.3064),
    light: art(bidRequestsLightGlyph, 60, 60),
  },
  landScoring: plain(landScoringGlyph, landScoringLightGlyph),
  createParcels: badged(createParcelsGlyph, createParcelsLightGlyph),
  notifications: plain(notificationsGlyph, notificationsLightGlyph),
  settings: plain(settingsGlyph, settingsLightGlyph),
  systemAlerts: plain(systemAlertsGlyph, systemAlertsLightGlyph),
};
